import { getGlobalTheme } from '@atlaskit/tokens/get-global-theme';
import { themeObjectToString } from '@atlaskit/tokens/theme-state-transformer';

/**
 * Reads the host page's active theme from `document.documentElement` and
 * serialises it into the format expected by the `initial-theme` query
 * parameter (space-separated `key:value` pairs including `colorMode`).
 *
 * Returns `undefined` when the theme cannot be determined (e.g. SSR or
 * no theme attributes on the page).
 */
export const getInitialThemeParam = (): string | undefined => {
	const theme = getGlobalTheme();

	if (Object.keys(theme).length === 0) {
		return undefined;
	}

	return themeObjectToString(theme);
};
